import type { TransmissaoFonte } from '@/shared/types';

/**
 * Extrai o ID de 11 caracteres de uma URL ou string YouTube.
 */
export function extrairYoutubeVideoId(input: string | null | undefined): string | null {
  if (!input?.trim()) return null;
  const trimmed = input.trim();

  if (/^[\w-]{11}$/.test(trimmed)) return trimmed;

  try {
    const url = trimmed.startsWith('http') ? new URL(trimmed) : new URL(`https://${trimmed}`);

    if (url.hostname.includes('youtu.be')) {
      const id = url.pathname.slice(1).split('/')[0];
      return id && /^[\w-]{11}$/.test(id) ? id : null;
    }

    if (url.hostname.includes('youtube.com')) {
      const v = url.searchParams.get('v');
      if (v && /^[\w-]{11}$/.test(v)) return v;

      const embed = url.pathname.match(/\/embed\/([\w-]{11})/);
      if (embed?.[1]) return embed[1];

      const live = url.pathname.match(/\/live\/([\w-]{11})/);
      if (live?.[1]) return live[1];
    }
  } catch {
    return null;
  }

  return null;
}

/**
 * Resolve o video_id efetivo: override da tela > ID cadastrado na fonte.
 */
export function resolverVideoIdTransmissao(
  override: string | null | undefined,
  fonte: Pick<TransmissaoFonte, 'youtube_video_id'> | null | undefined,
): string | null {
  return (
    extrairYoutubeVideoId(override ?? null)
    ?? extrairYoutubeVideoId(fonte?.youtube_video_id ?? null)
  );
}
